import * as React from 'react';
import { forwardRef } from 'react';
import type { Ref } from 'react';

import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';
function SvgModelsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 16" {...props}>
      <g clipPath="url(#ModelsIcon_svg__a)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M0 4.75a2.75 2.75 0 0 1 5.145-1.353l4.372-.95a2.75 2.75 0 1 1 3.835 2.823l.282 2.257a2.75 2.75 0 1 1-2.517 4.46l-2.62 1.145.003.118a2.75 2.75 0 1 1-4.415-2.19L3.013 7.489A2.75 2.75 0 0 1 0 4.75ZM2.75 3.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm2.715 1.688c.018-.11.029-.22.033-.333l4.266-.928a2.753 2.753 0 0 0 2.102 1.546l.282 2.257c-.377.165-.71.412-.976.719L5.465 5.188ZM4.828 6.55a2.767 2.767 0 0 1-.413.388l1.072 3.573a2.747 2.747 0 0 1 2.537 1.19l2.5-1.093a2.792 2.792 0 0 1 .01-.797l-5.706-3.26ZM12 10.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM5.75 12a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM11 2.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="ModelsIcon_svg__a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ModelsIcon = forwardRef((props: IconProps, forwardedRef?: Ref<HTMLSpanElement>) => {
  return <Icon ref={forwardedRef} {...props} component={SvgModelsIcon} />;
});
ModelsIcon.displayName = 'ModelsIcon';
export default ModelsIcon;
